"use client";
/*
 * Documentation:
 * OW_Footer — https://app.subframe.com/4f62853ee923/library?component=OW_Footer_97531722-b413-4860-9894-5d099bd0ecf1
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Ow_FooterRootProps extends React.HTMLAttributes<HTMLDivElement> {
  copyrightText?: React.ReactNode;
  links?: React.ReactNode;
  className?: string;
}

const Ow_FooterRoot = React.forwardRef<HTMLDivElement, Ow_FooterRootProps>(
  function Ow_FooterRoot(
    { copyrightText, links, className, ...otherProps }: Ow_FooterRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "flex w-full flex-col items-center justify-center bg-neutral-950",
          className
        )}
        ref={ref}
        {...otherProps}
      >
        <div className="flex w-full items-center px-6 py-4 flex-col sm:flex-row justify-between max-w-[920px] gap-2 sm:gap-8">
          {copyrightText ? (
            <span className="text-caption font-caption text-neutral-0">
              {copyrightText}
            </span>
          ) : null}
          {links ? (
            <div className="flex items-center gap-4">{links}</div>
          ) : null}
        </div>
      </div>
    );
  }
);

export const Ow_Footer = Ow_FooterRoot;
